/**
 * Main Nav
 * 
 * This script leverages Bootstrap's existing dropdown initialization
 * On mobile, first-level menu items change to "← Previous Menu" when opened.
 * Communicates with mega menu to hide/show dropdown toggle when navigating sublevels.
 * 
 * @type {Drupal.Behavior}
 * 
 * @param {Drupal.Context} context - The context of the current page.
 */

(function (Drupal, once) {
  'use strict';
  
  Drupal.behaviors.mainNav = {
    attach: function (context) {
      // Mobile detection function
      function isMobile() {
        return window.innerWidth <= 992;
      }

      // Process each navigation dropdown
      once('main-nav-mobile', '.nav-pseudo .dropdown-toggle', context).forEach(function (dropdownToggle) {
        const originalText = dropdownToggle.textContent.trim();
        const mobileText = '← Previous Menu';
        
        // Store original text as data attribute for easy retrieval
        dropdownToggle.setAttribute('data-original-text', originalText);
        
        // Track visibility state for mega menu communication
        let isHiddenByMegaMenu = false;

        /**
         * Hide the dropdown toggle (remove from DOM flow)
         */
        function hideDropdownToggle() {
          if (isMobile() && !isHiddenByMegaMenu) {
            dropdownToggle.style.display = 'none';
            isHiddenByMegaMenu = true;
            console.log('Main nav toggle hidden by mega menu');
          }
        }

        /**
         * Show the dropdown toggle (restore to DOM flow)
         */
        function showDropdownToggle() {
          if (isMobile() && isHiddenByMegaMenu) {
            dropdownToggle.style.display = '';
            isHiddenByMegaMenu = false;
            console.log('Main nav toggle shown by mega menu');
          }
        }

        /**
         * Force restore dropdown toggle visibility (used when mega menu closes)
         */
        function forceRestoreDropdownToggle() {
          if (isHiddenByMegaMenu) {
            dropdownToggle.style.display = '';
            isHiddenByMegaMenu = false;
            console.log('Main nav toggle force restored');
          }
        }

        // Listen for dropdown show event
        dropdownToggle.addEventListener('show.bs.dropdown', function (event) {
          if (isMobile() && !isHiddenByMegaMenu) {
            event.target.textContent = mobileText;
            
            // Add mobile-specific classes for styling
            event.target.classList.add('mobile-dropdown-active');
          }
        });

        // Listen for dropdown hide event
        dropdownToggle.addEventListener('hide.bs.dropdown', function (event) {
          if (isMobile()) {
            const storedOriginalText = event.target.getAttribute('data-original-text');
            event.target.textContent = storedOriginalText || originalText;
            
            // Remove mobile-specific classes
            event.target.classList.remove('mobile-dropdown-active');
            
            // Always restore visibility when dropdown closes
            forceRestoreDropdownToggle();
          }
        });

        // Listen for mega menu events
        document.addEventListener('megaMenu.sublevelEntered', function(event) {
          if (event.detail.toggle === dropdownToggle && event.detail.isMobile) {
            hideDropdownToggle();
          }
        });

        document.addEventListener('megaMenu.rootReturned', function(event) {
          if (event.detail.toggle === dropdownToggle && event.detail.isMobile) {
            showDropdownToggle();
          }
        });

        document.addEventListener('megaMenu.megaMenuClosed', function(event) {
          if (event.detail.toggle === dropdownToggle) {
            forceRestoreDropdownToggle();
          }
        });

        // Handle window resize to reset text if switching from mobile to desktop
        // while dropdown is open
        window.addEventListener('resize', function () {
          const isCurrentlyMobile = isMobile();
          const isDropdownOpen = dropdownToggle.getAttribute('aria-expanded') === 'true';
          
          if (!isCurrentlyMobile && isDropdownOpen) {
            // If switching to desktop while dropdown is open, restore original text
            const storedOriginalText = dropdownToggle.getAttribute('data-original-text');
            dropdownToggle.textContent = storedOriginalText || originalText;
            dropdownToggle.classList.remove('mobile-dropdown-active');
            
            // Always restore visibility when switching to desktop
            forceRestoreDropdownToggle();
          } else if (isCurrentlyMobile && isDropdownOpen) {
            // If switching to mobile while dropdown is open, apply mobile text
            // Only if not hidden by mega menu
            if (!isHiddenByMegaMenu) {
              dropdownToggle.textContent = mobileText;
              dropdownToggle.classList.add('mobile-dropdown-active');
            }
          } else if (!isCurrentlyMobile) {
            // If switching to desktop, always restore visibility
            forceRestoreDropdownToggle();
          }
        });
      });

    }
  };
})(Drupal, once);